

































import { Mixins } from "vue-property-decorator";
import Component from "vue-class-component";
import { RED } from "@/resources/constants/busyReasons";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "speed-networking-enter-component",
})
export default class SpeedNetworkingComponent extends Mixins(Plans) {
  PLAN = PLAN;
  get active() {
    return this.$store.getters["SpeedNetworkingStore/getShowEnterModal"];
  }
  set active(e) {
    this.$store.dispatch("SpeedNetworkingStore/setShowEnterModalAction", e);
  }

  onCancel() {
    this.active = false;
  }
  onEnter() {
    if (!this.activeOptionPlan(PLAN.NETWORKING))
      return;
    this.active = false;
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    this.$store.dispatch("SpeedNetworkingStore/joinSpeedNetworkingAction", {
      roomId,
      callback: async (data) => {
        await this.$store.dispatch(
          "SpeedNetworkingStore/setWaitingTimeAction",
          data.nextSpeedNetworkingCycleTime
        );
        const userLocal = this.$store.getters["UserStore/getSpaceUser"];
        const pre_status = {
          availableStatus: userLocal.superSpaceUser.user.availableStatus,
          availableStatusReason:
            userLocal.superSpaceUser.user.availableStatusReason,
          emoji: localStorage.getItem("default_emoji"),
        };
        localStorage.setItem("pre_status", JSON.stringify(pre_status));
        await this.$store.dispatch("UserStore/updateUserStatusAction", {
          userId: userLocal.superSpaceUser.user.id,
          props: {
            availableStatus: RED.type,
            availableStatusReason: null,
            emoji: "U+1F4DE",
          },
          callback: async () => {
            // do nothing
          },
        });

        await this.$store.dispatch(
          "MeetingStore/setMeetingTypeAction",
          MEETING_TYPE.SPEED_NETWORKING
        );
        await this.$store.dispatch(
          "SpeedNetworkingStore/setEnterInNetworkingAction",
          true
        );
      },
    });
  }
}
